
import BaseMixin from '@/views/mixin.vue'
import { mapState, mapGetters } from 'vuex'
import { HttpSaLockList, HttpDealSaLock, HttpDelSaLock } from '@/service/boss/allot';

import compSearch from './search';
import compDetail from './detail';
import compUpdate from './update';

import { Dropdown, Icon, Button } from 'view-design'


export default {
    mixins: [BaseMixin],
    components: {
        compSearch,
        compDetail,
        compUpdate,
    },
    data () {
        return {
            data: [],
            checkedId: [],
        };
    },
    methods: {
        httpList: HttpSaLockList,
        handleOperates (id, type, row) {
            this.operate = {};
            switch (type) {
                case 'query':
                    this.operate = {
                        id,
                        title: '查看',
                        component: 'compDetail',
                        show: true,
                        width: 720,
                        type
                    }; break;
                case 'cancel':
                    this.checkedId = !id ? this.checkedId : [id];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning('请选择至少一条数据');
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: '取消操作',
                        type
                    }
                    break;
                case 'operate':
                    if (this.checkedId.length == 0) {
                        this.$Message.warning('请选择至少一条数据');
                        return;
                    }
                    this.operate = {
                        title: '处理操作',
                        type,
                        ids: this.checkedId,
                        show: true,
                        component: 'compOperate',
                        width: 520,
                    }
                    break;
                case 'operateone':
                    this.operate = {
                        title: '处理操作',
                        type,
                        id,
                        show: true,
                        component: 'compUpdate',
                        width: 720,
                    }
                    break;
            }
        },
        download () {
            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/StockTransfer/excel", {}, 'download')
        },
        exportFile (ids) {
            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/StockTemplate/export", { ids: ids }, 'download')
        },
        async batchOpearte () {
            let request, { type, id } = this.operate, params = {}, callback = (res) => { this.$Message.success(res.message); };
            switch (type) {
                case 'cancel': request = HttpDelSaLock; params = { ids: this.checkedId.join(',') || id }; break;
                case 'operate': request = HttpDealSaLock; params = { ids: this.checkedId.join(',') || id }; break;
            }
            if (!request) return;
            request(params).then(res => {
                this.$Message.success(res.message);
                this.updateList();
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            }).finally(result => {
                this.showDel = false;
                this.operate = {};
            });
        },
    },
    computed: {
        ...mapState('boss', ['products', 'accounts']),
        ...mapGetters('boss', ['warehouses']),
        columns () {
            return [{
                width: 55,
                type: "selection",
            }, {
                title: "操作",
                width: 168,
                render: (h, { row }) => {
                    const id = row.id, show = row.status !== 'CANCEL'
                    return <div>
                        <Button size='small' type='primary' class='margin-right-5' onClick={this.handleOperates.bind(this, id, 'query')}>查看</Button>
                        <Button size='small' type='info' class='margin-right-5' onClick={this.handleOperates.bind(this, id, 'operateone')}>处理</Button>
                        <Button v-show={show} size='small' type='error' onClick={this.handleOperates.bind(this, id, 'cancel')}>取消</Button>
                    </div>
                }
            },
            {
                title: '#ID',
                width: 76,
                key: 'id',
                sortable: true,
            },
            {
                title: '基本信息',
                key: 'lineId',
                sortable: true,
                render: (h, { row }) => {
                    const lined = row.lineId, orgId = row.orgWarehouseId,
                        resultLined = this.products.filter((item) => {
                            return item.id === lined;
                        })[0] || {},
                        resultOrg = this.warehouses.filter((item) => {
                            return item.id === orgId;
                        })[0] || {};
                    return <span>项目：{resultLined.name}<br />仓库：{resultOrg.title}<br />店铺：{row.accountFlag}</span>
                }
            },
            // {
            //     title: '店铺',
            //     key: 'accountFlag',
            //     sortable: true,
            // },
            // {
            //     title: "仓库",
            //     key: "orgWarehouseId",
            //     render: (h, { row }) => {
            //         const id = row.orgWarehouseId,
            //             result = this.warehouses.filter((item) => {
            //                 return item.id === id;
            //             })[0] || {};
            //         return <span>{result.title}</span>
            //     }
            // },
            {
                title: 'SKU',
                key: 'erpSku',
                sortable: true,
                render (h, { row }) {
                    return <div>
                        ERPSKU：{row.erpSku}<br />
                        Seller SKU：{row.sellerSku}
                    </div>
                }
            }, {
                title: '锁定信息',
                key: 'quantity',
                minWidth: 100,
                sortable: true,
                render (h, { row }) {
                    return <div>
                        锁定数量:{row.quantity}<br />
                        锁定时间:{row.beginDate}~{row.endDate}<br />
                        更新时间:{row.updatedAt}
                    </div>
                }
            }, {
                title: '提醒消息',
                key: 'errorMessage',
                sortable: true,
            },
            // {
            //     title: "处理结果",
            //     key: "dealStatus",
            //     render: (h, { row }) => {
            //         const status = row.dealStatus;
            //         switch (status) {
            //             case 0: return <Button class="cursor-default" type='primary' size='small'>待处理</Button>; break;
            //             case 1: return <Button class="cursor-default" type='success' size='small'>已处理</Button>; break;
            //             case 9: return <Button class="cursor-default" type='error' size='small'>异常</Button>; break;
            //             default: return <Button class="cursor-default" type='primary' size='small'>待处理</Button>; break;
            //         }
            //     }
            // }, 
            // {
            //     title: "更新时间",
            //     key: "updatedAt",

            // }, 
            {
                title: '状态',
                width: 80,
                key: 'status',
                sortable: true,
                render: (h, { row }) => {
                    const status = row.status;
                    switch (status) {
                        case 'ACTIVATE': return <Button class="cursor-default" type='success' size='small'>激活</Button>; break;
                        case 'DRAFT': return <Button class="cursor-default" type='primary' size='small'>草稿</Button>; break;
                        case 'CANCEL': return <Button class="cursor-default" type='error' size='small'>取消</Button>; break;
                        default: return <Button class="cursor-default" type='primary' size='small'>草稿</Button>; break;
                    }
                }
            }];
        },
    },
};




